<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_517')}}</div>
    <div slot="body">
      <p>{{$t('scope.text_518')}}<span class="company">{{ params.data[0].enterprise_name }}</span>{{$t('scope.text_519')}}</p>
       <a-form
        :form="form.fc">
        <a-form-item :label="$t('scope.text_520')" v-bind="formItemLayout">
          <a-textarea
            :placeholder="$t('scope.text_520')"
            v-decorator="decorators.description"
            :autoSize="{ minRows: 2, maxRows: 6 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TenantRefuseDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      scope: this.$store.getters.scope,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        description: [
          'description',
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  methods: {
    doAuthenticate (data) {
      return new this.$Manager('customers').performAction({
        action: 'enterprise-review',
        id: this.params.data[0].id,
        data: data,
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doAuthenticate({ approved: false, ...values })
        this.loading = false
        this.cancelDialog()
        this.$bus.$emit('tenant:refuseSuccess')
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "~@/styles/less/theme";

.company {
  color: @warning-color;
}
</style>
